/**
 * Convert a file to base64 string
 * @param {File} file - The file to convert
 * @returns {Promise<string>} Base64 encoded string
 */
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

/**
 * Check if file is an image
 * @param {File} file - The file to check
 * @returns {boolean}
 */
export const isImage = (file) => {
  return file.type.startsWith('image/');
};

/**
 * Check if file is a PDF
 * @param {File} file - The file to check
 * @returns {boolean}
 */
export const isPDF = (file) => {
  return file.type === 'application/pdf';
};

/**
 * Validate file for base64 encoding
 * Only small images (< 1MB) can be stored as base64 in Firestore
 * @param {File} file - The file to validate
 * @returns {{valid: boolean, reason?: string}}
 */
export const validateFileForBase64 = (file) => {
  const maxSize = 1 * 1024 * 1024; // 1MB limit for base64 storage
  
  if (!isImage(file) && !isPDF(file)) {
    return { valid: false, reason: 'File must be an image or PDF' };
  }
  
  if (isPDF(file)) {
    return { valid: false, reason: 'PDFs must be uploaded via URL. Please host your PDF elsewhere and paste the URL.' };
  }
  
  if (file.size > maxSize) {
    return { 
      valid: false, 
      reason: `Image is too large (${(file.size / 1024 / 1024).toFixed(2)}MB). Maximum size for direct upload is 1MB. Please use a URL instead.` 
    };
  }
  
  return { valid: true };
};





